import FerryHandlingTime from "../components/ferryHandlingTime/ferryHandlingTime";
import InvoiceAttachment from "../components/invoiceAttachment/invoiceAttachment";
import SeaFerriesSummary from "../components/seaFerriesSummary/seaFerriesSummary";
import TransportRegister from "../components/transportRegister/transportRegister";
import VehicleOrCargoHandlingTime from "../components/vehicleOrCargoHandlingTime/vehicleOrCargoHandlingTime";
import DangerousGoodsRegister from "../components/dangerousGoodsRegister/dangerousGoodsRegister";
import TrailerBase from "../components/trailerBase/trailerBase";
import ListOfShipments from "../components/listOfShipments/listOfShipments";
import {UserRoles} from "../../helpers/userRoles";

export enum reportsRoutingAddress {
    seaFerriesSummary = "/reports/sea-ferries-summary",
    transportRegister = "/reports/transport-register",
    ferryHandlingTime = "/reports/ferry-handling-time",
    vehicleOrCargoHandlingTime = "/reports/vehicle-or-cargo-hadling-time",
    invoiceAttachment = "/reports/invoice-attachment",
    dangerousGoodsRegister = "/reports/dangerous-goods-register",
    trailerBase = "/reports/trailer-base",
    listOfShipments = "/reports/list-of-shipments"
}

export const reportsRoutes = [
    {
        path: reportsRoutingAddress.seaFerriesSummary,
        component: SeaFerriesSummary,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.transportRegister,
        component: TransportRegister,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.ferryHandlingTime,
        component: FerryHandlingTime,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.vehicleOrCargoHandlingTime,
        component: VehicleOrCargoHandlingTime,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.invoiceAttachment,
        component: InvoiceAttachment,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.dangerousGoodsRegister,
        component: DangerousGoodsRegister,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.trailerBase,
        component: TrailerBase,
        roles: [UserRoles.reportsView]
    },
    {
        path: reportsRoutingAddress.listOfShipments,
        component: ListOfShipments,
        roles: [UserRoles.reportsView]
    }
];
